import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { fetchItemSummaries } from '@/redux/modules/item/summary/itemSummary.actions';
import { fetchItemCarouselsIfNeeded } from '@/redux/modules/itemCarousel/itemCarousel.actions';
import { getCarousels } from '@/redux/modules/itemCarousel/itemCarousel.selectors';
import { fetchItemFacetsIfNeeded } from '@/redux/modules/itemFacets';
import { getPriceResults, getPriceResultsData } from '@/redux/modules/priceResults/priceResults.actions';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { getItemIdFromPath } from '@/utils/urls';

import { getPriceResultsSimilarUpcomingItemIds } from './getPriceResultsSimilarUpcomingItemIds';

export const priceResultPageData = async ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch, getState } = store;
    const slug = params.slugId;
    const slugItemId = getItemIdFromPath(`/item/${slug}`);
    const loggedIn = isUserLoggedIn(getState());

    // Always fetch price result meta (lotId, slug, etc.). Sales history only when logged in.
    const getPriceResultsDataUnwrap = dispatch(getPriceResultsData(slug)).unwrap();
    const getPriceResultsUnwrap = loggedIn ? dispatch(getPriceResults({ slug })).unwrap() : undefined;

    const priceResultPayloads = await Promise.all(
        getPriceResultsUnwrap ? [getPriceResultsDataUnwrap, getPriceResultsUnwrap] : [getPriceResultsDataUnwrap]
    );

    const itemId = priceResultPayloads[0]?.lotId ?? (slugItemId || 0);

    const promises = [];
    if (itemId) {
        promises.push(dispatch(fetchItemFacetsIfNeeded([itemId])));
        // Same rationale as item page: omit ItemModel `similarItems` (see `fetchDataForItemPage`).
        promises.push(
            dispatch(
                fetchItemSummaries({
                    force: true,
                    identifier: 'price-results-page',
                    itemIds: [itemId],
                })
            )
        );
        // Fetch carousel data first UseNewSimilarItems is always true
        await dispatch(
            fetchItemCarouselsIfNeeded({
                itemId,
                shouldUseSignalsBoost: true,
                useNewSimilarItems: true,
                useScoutCategories: true,
            })
        );

        const state = store.getState();
        const carousels = getCarousels(state, itemId);
        const carouselItemIds = getPriceResultsSimilarUpcomingItemIds(carousels);

        if (carouselItemIds.length > 0) {
            promises.push(
                dispatch(
                    fetchItemSummaries({
                        identifier: 'price-results-carousel-items',
                        itemIds: carouselItemIds,
                    })
                )
            );
        }
    }
    await Promise.all(promises);

    return Promise.resolve();
};
